export default __webpack_public_path__ + "static/importance_of_bio-4839f60db73849f36909a05bbf14f93d.jpg";